import { Switch } from "@progress/kendo-react-inputs"
import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { editCaseManDocumentRequest } from "../../../../../services/caseManService/model/caseMan/CaseManagementSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function OtherDocumentRequest(){
    const dispatch=useAppDispatch();
    const caseMan = useAppSelector((state) => state.caseManagement.caseManagement);

    return <React.Fragment>
        <div>
            <label>Other Documents</label><br/>
            <Switch value={caseMan.documentRequest?.otherDocument}
                checked={caseMan.documentRequest?.otherDocument}
                onChange={(e)=>dispatch(editCaseManDocumentRequest(new ReduxUpdate('otherDocument',e.target.value)))}/>
        </div>
    </React.Fragment>
}
export {OtherDocumentRequest}